import bem from 'utils/bem';

export const socialShareModalBlock = bem('social-share-modal');
export const socialShareModalAccountSelectBlock = bem(
  'social-share-modal-account-select',
);
export const socialShareModalFooterBlock = bem('social-share-modal-footer');
export const socialShareModalRegenerateTextButtonBlock = bem(
  'social-share-modal-regenerate-text-button',
);
